<script>
  import QuestionFrame from './QuestionFrame.svelte';
</script>

<QuestionFrame>
  <p>Helfen Ihnen Schmerzmedikamente wenig bis gar nicht?</p>
</QuestionFrame>
